import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../common/dropdown'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import { Tooltip } from '../../../common/tooltip'
import { selectCheckedProfileIds, selectCustomProfileIds } from '../store/slice'
import { deleteAlertProfile, getAlertSettingsDynamic } from '../store/thunk'

import classes from './index.module.scss'

export const ToolBar = () => {
  const dispatch = useDispatch()

  const customProfileIds = useSelector(selectCustomProfileIds)
  const checkedProfileIds = useSelector(selectCheckedProfileIds())
  const listChecked = customProfileIds.filter((id) => checkedProfileIds[id])

  const [isLoading, setIsLoading] = useState(false)
  const [isShow, setIsShow] = useState(false)

  const handleOpen = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const handleDelete = () => {
    setIsLoading(true)

    dispatch(deleteAlertProfile({ alertProfileIds: listChecked }))
      .then(() => {
        dispatch(getAlertSettingsDynamic())
      })
      .finally(() => {
        setIsLoading(false)
        handleClose()
      })
  }

  const actions = [
    {
      icon: 'icon-trash-fill',
      tooltip: 'common.DELETE',
      color: '#2C73E8',
      bgColor: '#F2F7FF',
      action: handleOpen,
    },
  ]

  if (!listChecked.length) return null

  return (
    <>
      <Element className={classes.toolbar} style={{ color: '#3A414B' }}>
        <Translate
          value="alerts.ITEM_SELECTED_COUNT"
          count={listChecked.length}
          suffix={listChecked.length > 1 ? 's' : ''}
        />
        {actions.map((item, index) => (
          <Element
            key={index}
            className={classes.icon}
            style={{ backgroundColor: item.bgColor }}
            onClick={item.action}
          >
            <Tooltip
              tooltipContent={item.tooltip}
              isI18n
              position={positionDropdown.BOTTOM_CENTER}
              contentClass={classes.icon}
            >
              <Icon
                className={item.icon}
                style={{ color: item.color, fontSize: 15 }}
              />
            </Tooltip>
          </Element>
        ))}
      </Element>

      <PopupAction
        isShow={isShow}
        title="alertSetting.DELETE_PROFILE_TITLE"
        btnCancel={{
          label: 'common.CANCEL',
          isI18n: true,
          event: handleClose,
          disabled: isLoading,
        }}
        btnSubmit={{
          label: 'common.DELETE',
          isI18n: true,
          event: handleDelete,
          disabled: isLoading,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate
              value="alertSetting.DELETE_PROFILES_MESS"
              count={listChecked.length}
            />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
